import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";

const Chapter2_5 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welche Methode gehört zu den häufigsten Social-Engineering-Angriffen?",
      options: [
        {
          value: "A",
          label:
            "Phishing, bei dem Angreifer gefälschte E-Mails oder Webseiten nutzen, um sensible Daten wie Passwörter zu stehlen.",
        },
        {
          value: "B",
          label:
            "Das automatisiertes Ausprobieren von Passwörtern ist eine typische Social-Engineering-Methode.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Wie funktioniert ein Quid Pro Quo Angriff im Kontext von Social Engineering?",
      options: [
        {
          value: "A",
          label:
            "Bei einem Quid Pro Quo Angriff gibt sich der Angreifer oft als technischer Support aus und bietet einen Service an, im Austausch für den Zugang zu sensiblen Informationen oder Systemen.",
        },
        {
          value: "B",
          label:
            "Bei einem Quid Pro Quo Angriff verspricht der Angreifer, das Opfer zu entschädigen, wenn es ihm den Datenzugang ermöglicht.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 2_5.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "2_5",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("2_5"),
            });
          console.log("Dokument aktualisiert mit Kapitel 2_5.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "2_5",
              completedChapters: ["2_5"],
            });
          console.log("Dokument erstellt mit Kapitel 2_5.");
        }

        navigate("/3_1"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  2: Sicherheitslücken und Schwachstellen
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Social Engineering Attacks
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center pt-5">
            Kapitel 2: Sicherheitslücken und Schwachstellen
          </h3>
          <h2 className="text-center p-5">Social Engineering Attacks</h2>
          <img
            src="./images/social.webp"
            alt="Sicherheitsluecke"
            style={{ position: "relative", maxWidth: "30%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <p className="pt-5 col-lg-11 mx-auto">
            Social Engineering Attacks (Social-Engineering-Angriffe) gehören zu
            den raffiniertesten Methoden, um in IT-Systeme einzudringen oder
            sensible Informationen zu stehlen. Im Gegensatz zu rein technischen
            Angriffen, die Schwachstellen in Software oder Netzwerken suchen,
            nutzen Social-Engineering-Angriffe die
            <strong>
              {" "}
              menschliche Psyche bzw. typisch menschliche Verhaltensweisen{" "}
            </strong>
            aus. Dabei finden Social Engineering Attacks nicht nur über digitale
            Kanäle statt, sondern auch im persönlichen Kontakt oder am Telefon.
            <br />
            <br />
            Bei einem solchen Angriff bauen die Täter eine scheinbar
            vertrauenswürdige Beziehung auf oder schaffen eine stressige
            Situation, um das Opfer zu einer schnellen und unüberlegten Reaktion
            zu verleiten. Sie nutzen dabei Verhaltensweisen wie
            Autoritätshörigkeit, Neugierde und Hilfsbereitschaft des Opfers aus.
            Sie verwenden z. B. glaubwürdige Vorwände und gut recherchierte
            Informationen, um ihre Geschichten echt wirken zu lassen und das
            Opfer zu täuschen. <br />
            <br />
            Die Social Engineering Attacks unterscheiden sich hinsichtlich ihrer
            psychologischen Vorgehensweisen und Methoden:{" "}
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Pretexting</h3>
            <p className="col-lg-11 mx-auto">
              Der Angreifer entwirft ein <strong> gefälschtes Szenario </strong>{" "}
              oder einen „Pretext“, um das Vertrauen des Opfers zu gewinnen. Er
              gibt sich beispielsweise als eine vertrauenswürdige Person oder
              Institution aus, etwa als IT-Support, eine Bank oder sogar als ein
              Kollege. Durch geschicktes Fragen und das Schaffen einer
              glaubwürdigen Geschichte gelingt es dem Angreifer, das Opfer dazu
              zu bringen, sensible Informationen preiszugeben. Diese Methode ist
              besonders effektiv, wenn der Angreifer zuvor Informationen über
              das Opfer gesammelt hat, um die Täuschung überzeugender zu
              gestalten. Pretexting setzt oft auf das Vertrauen in und den
              Respekt vor Autoritätspersonen oder bekannten Institutionen.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Beispiel: Ein Angreifer ruft einen Mitarbeiter in der
              Finanzabteilung eines Unternehmens an und gibt sich als
              Sicherheitsbeauftragter der IT-Abteilung aus. Der Angreifer
              behauptet, dass es ein Problem mit der internen Finanzsoftware
              gibt, das dringend behoben werden muss, um Datenverlust zu
              vermeiden. Um das Problem zu lösen, „benötigt er dringend" die
              Anmeldeinformationen des Mitarbeiters für die
              Buchhaltungssoftware. Da der Angreifer das Vertrauen des
              Mitarbeiters durch das Auftreten als Kollege und Autoritätsperson
              erlangt hat, übergibt der Mitarbeiter die Informationen, ohne
              Verdacht zu schöpfen.
            </p>
            <p className="pb-5 col-lg-11 mx-auto">
              Hier nutzt der Angreifer das Vertrauen und den Stressfaktor, um an
              die Anmeldeinformationen zu gelangen, die dann für unbefugte
              Transaktionen oder Datenzugriffe verwendet werden.
            </p>
          </div>
        </div>
      </div>
      <div className="white-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Baiting</h3>
            <p className="col-lg-11 mx-auto">
              Beim Baiting werden Opfer durch ein{" "}
              <strong> verlockendes Angebot </strong> oder eine attraktive Falle
              dazu gebracht, auf einen Köder hereinzufallen. Dies kann
              beispielsweise durch die Platzierung eines infizierten USB-Sticks
              an einem öffentlichen Ort geschehen, der mit der Beschriftung
              "Geheime Gehaltsdaten" oder "Vertraulich" versehen ist. Die
              Neugierde einer beliebigen Person führt dazu, dass sie den
              USB-Stick in ihren Computer steckt, wodurch schädlicher Code
              installiert wird.
              <br /> <br />
              Baiting kann auch in digitaler Form auftreten, etwa durch
              verlockende Download-Angebote oder gefälschte Werbebanner. Ein
              Angreifer bietet in einer E-Mail oder auf einer gefälschten
              Website ein kostenloses Software-Upgrade, einen nützlichen
              Ratgeber oder einen verlockenden Rabatt für ein Produkt an, mit
              einem auffälligen „Jetzt herunterladen“-Button. Sobald der
              Benutzer auf den Button klickt, wird anstelle des beworbenen
              Inhalts eine Schadsoftware auf den Computer des Opfers
              heruntergeladen.
              <br /> <br />
              Ein klassisches Beispiel wären auch Pop-up-Anzeigen auf
              fragwürdigen Webseiten, die den Benutzer dazu auffordern, ein
              angeblich dringend erforderliches Update für eine oft verwendete
              Software (z. B. Adobe Flash oder ein Browser-Plugin)
              herunterzuladen. In Wirklichkeit handelt es sich um schädliche
              Software, die das System infiziert oder Daten stiehlt.
            </p>{" "}
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Beispiel: Ein Nutzer erhält eine E-Mail von einem bekannten
              Online-Shop mit dem Betreff "Exklusiver Gewinn! Ihr kostenloses
              Smartphone wartet!". Die Nachricht enthält einen Link zu einer
              angeblichen Webseite des Shops, die ihn auffordert, sich mit
              seinen Anmeldedaten einzuloggen.
            </p>{" "}
            <p className="pb-5 col-lg-11 mx-auto">
              In diesem Fall ist die Aussicht auf den Gewinn der Köder (Bait),
              der das Opfer aus Gier dazu bringt, eine potenziell gefährliche
              Handlung auszuführen.
            </p>
          </div>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Smishing</h3>
            <p className="col-lg-11 mx-auto">
              Smishing ist eine Form des Phishings, bei der Betrugsversuche per SMS oder Messenger-Nachricht erfolgen. Die Täter verschicken Nachrichten, die beispielsweise wie eine Paketbenachrichtigung, eine Bankwarnung oder eine Mitteilung vom Mobilfunkanbieter aussehen. Oft wird dabei Zeitdruck aufgebaut („Ihr Konto wird gesperrt“, „Zustellung fehlgeschlagen“), um das Opfer dazu zu bringen, auf einen Link zu klicken und persönliche Daten einzugeben.
              <p className="col-lg-11 mx-auto">Der enthaltene Link führt meist auf eine gefälschte Website, die dem Original täuschend ähnlich sieht. Dort sollen Zugangsdaten, Kreditkarteninformationen oder TAN-Nummern eingegeben werden. Da SMS als persönlicher und weniger verdächtig wahrgenommen werden als E-Mails, sind viele Menschen bei Smishing besonders anfällig.</p>
            </p>{" "}
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
             Im Sommer 2025 wurden in mehreren Ländern Betrugs-SMS verschickt, die angeblich von Paketdiensten wie DHL oder UPS stammten. Die Nachrichten behaupteten, dass ein Paket nicht zugestellt werden konnte und dass der Empfänger einen Link anklicken solle, um den Lieferstatus zu aktualisieren oder eine Gebühr zu bezahlen. Wer auf den Link klickte, wurde auf eine gefälschte Login-Seite weitergeleitet, auf der er seine Kontodaten eingeben sollte – die dann von den Angreifern abgegriffen wurden.


            </p>
            <p className="col-lg-11 mx-auto">
              Solche Smishing-Kampagnen nutzen typische menschliche Erwartungen (Paketbenachrichtigungen), um Vertrauen zu erzeugen und dazu zu bringen, auf Links zu klicken oder Daten preiszugeben. Sie sind oft schwer von echten Mitteilungen zu unterscheiden, weil sie personalisierte Informationen enthalten und offizielle Absender imitieren.
            </p>
          </div>
        </div>
      </div>
      <div className="white-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Quid Pro Quo</h3>
            <p className="col-lg-11 mx-auto">
              "Quid Pro Quo" bedeutet übersetzt "dies für das". Im Gegensatz zum
              Baiting, bei dem der Angreifer einen einfachen Köder anbietet (z.
              B. einen USB-Stick oder einen Download), verspricht der Angreifer
              bei Quid Pro Quo oft direkte Hilfe oder{" "}
              <strong> eine Gegenleistung für die Zusammenarbeit </strong> des
              Opfers. In diesem Szenario gibt sich der Angreifer als technischer
              Support-Mitarbeiter aus. Er bietet einen kostenlosen Service an,
              wie z. B. die Behebung eines vermeintlichen Problems am Computer
              des Opfers. Im Gegenzug verlangt der Angreifer subversiv Zugang zu
              sensiblen Informationen oder Systemen.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Beispiel: Ein Angreifer gibt sich als Techniker eines
              IT-Dienstleisters aus und behauptet, dass er für ein dringendes
              Update zuständig ist und gerade an einem Problem arbeitet, das
              viele Mitarbeiter betrifft – zum Beispiel langsame Verbindungen
              oder Fehler bei der Software. Er bietet dem Mitarbeiter an, das
              Problem sofort zu beheben, falls der Mitarbeiter ihm seine
              Zugangsdaten gibt, damit der „Techniker“ aus der Ferne arbeiten
              kann. Der Mitarbeiter, der durch das scheinbare IT-Problem ohnehin
              gestresst ist und froh über die angebotene Hilfe, gibt dem
              Angreifer die Anmeldedaten, ohne lange darüber nachzudenken oder
              Böses zu vermuten.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="pt-5 container">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">Schutzmaßnahmen und Prävention</h3>
            <p className="col-lg-11 mx-auto">
              Der beste Schutz gegen Social-Engineering-Angriffe ist ein hohes
              Maß an{" "}
              <Link to="/2_2#saw" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Security Awareness
              </Link>{" "}
              (Sicherheitsbewusstsein) der Mitarbeitern. Die Bedrohungslage
              ändert sich ständig. Daher sollten Sicherheitsmaßnahmen und
              Schulungen regelmäßig aktualisiert werden, um neuen
              Angriffsmethoden zu entgegnen.
              <br />
              <br />
              Erfolgreiche Schulungsprogramme basieren auf einem{" "}
              <strong>mehrstufigen Schulungsansatz, </strong> der theoretisches
              Wissen mit praktischer Anwendung verbindet. Nach der theoretischen
              Vermittlung der grundlegenden Konzepte und Methoden des Social
              Engineerings folgt die Praxis. In einem Mix verschiedener
              Schulungsformate wie Online-Lernmodule, Präsenzworkshop mit
              direktem Erfahrungsaustausch und simulierten Phishing-Kampagnen,
              können die Mitarbeiter dann ihr Wissen in einer kontrollierten
              Umgebung anwenden.
              <br />
              <br />
              Die größte Herausforderung liegt in der{" "}
              <strong>
                nachhaltigen Implementierung der Schulungsmaßnahmen.{" "}
              </strong>
              Einmalige Schulungen reichen nicht aus, da sich Angriffsmethoden
              ständig weiterentwickeln. Stattdessen ist ein kontinuierliches
              Programm notwendig, das regelmäßige Auffrischungen und Updates
              beinhaltet. Dabei sollten die Schulungsinhalte stets an aktuelle
              Bedrohungen und die spezifischen Bedürfnisse des Unternehmens
              angepasst werden.
              <br />
              <br />
              Die Wirksamkeit der Schulungen sollte{" "}
              <strong>
                regelmäßig mit Erfolgskontrollen überprüft und zu Anpassungen
                der Schulungsmaßnahmen führen.
              </strong>{" "}
              Dazu werden verschiedene Metriken, wie Klickraten bei
              Phishing-Simulationen oder die Anzahl gemeldeter
              Sicherheitsvorfälle erstellt. Erforderlich ist eine positive
              Fehlerkultur: Mitarbeiter, die auf simulierte Angriffe
              hereinfallen, sollten nicht bestraft, sondern konstruktiv geschult
              werden.
              <br />
              <br />
              Die Integration der Schulungen in den Arbeitsalltag ist
              entscheidend für den langfristigen Erfolg. Security Awareness muss
              Teil der Unternehmenskultur werden, wobei{" "}
              <strong> Führungskräfte eine wichtige Vorbildfunktion </strong>
              einnehmen. Führungskräfte tragen die Verantwortung, da ihre
              Handlungen und Entscheidungen die Sicherheitskultur des gesamten
              Unternehmens prägen. Wenn das Management selbst
              Security-Awareness-Praktiken vorlebt, motiviert das die
              Mitarbeitenden, entsprechenden Standards zu folgen. Zudem sind
              Führungskräfte selbst Hauptziele für Cyberangriffe, weshalb ihr
              eigenes Verständnis von Sicherheitsrisiken entscheidend ist, um
              das Unternehmen effektiv vor Bedrohungen zu schützen.
              <br />
              <br />
              Nur wenn alle Mitarbeiter die Bedeutung von Cybersecurity
              verstehen und leben, kann sich ein Unternehmen gut gegen Social
              Engineering-Angriffe schützen. Daher verlangen alle{" "}
              <strong> Compliance-Richtlinien </strong> für viele Branchen
              regelmäßige Schulungen als Teil der Cybersecurity.
            </p>
          </div>
        </div>
      </div>
      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-11 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter2_5;
